// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__eHpsO","dragIcon":"Choice_dragIcon__2moUk","left":"Choice_left__3uGe2","input":"Choice_input__ruejR"};